import React from 'react'
import { Link, useHistory } from 'react-router-dom'
const Nav = ({
  loading,
  name,
  error,
  errorMessage,
  submitHandler,
  slug,
  dataChanged,
}) => {
  const history = useHistory()
  // `dataChanged` was accepted but ignored, so SAVE was always active. It is driven
  // by the baseline diff in ProductCreateScreen. Undefined => enabled, so any screen
  // that does not pass it keeps the old always-on behaviour.
  const saveDisabled = loading || dataChanged === false
  return (
    <>

      <nav className='navbar navbar-expand-lg bg-light sticky-top mb-4 z-3 productPage__navbar'>
        <div className='container'>
          <div>
            <Link
              to='/admin/productlist'
              className='productPageNavbar__discardBtn'
              onClick={(e) => {
                // Drive navigation ourselves so "Go back" returns to the ACTUAL
                // previous page. Fall back to the product list only when there is no
                // history to go back to (e.g. the edit URL was opened directly).
                e.preventDefault()
                if (
                  dataChanged === true &&
                  !window.confirm(
                    'You have unsaved changes. Leave this page and lose them?'
                  )
                ) {
                  return
                }
                if (window.history.length > 1) {
                  history.goBack()
                } else {
                  history.push('/admin/productlist')
                }
              }}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                fill='none'
                viewBox='0 0 24 24'
                strokeWidth='1.5'
                stroke='currentColor'
                className='w-6 h-6 me-2'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  d='M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3'
                />
              </svg>
              Go back
            </Link>

            {name && <a className='navbar-brand'>{name}</a>}
          </div>

          <div className='productPageNavbar__actionBtnBox'>
            <a
              href={`${process.env.REACT_APP_SITE_URL}/products/${slug}`}
              target='_blank'
              className='productPageNavbar__actionBtn'
            >
              View
            </a>

            <button
              onClick={(e) => submitHandler(e)}
              className={`productPageNavbar__actionBtn${saveDisabled ? ' productPageNavbar__actionBtn--disabled' : ''}`}
              type='submit'
              disabled={saveDisabled}
            >
              {loading ? 'Saving...' : 'Save'}
            </button>

          </div>
        </div>
      </nav>
      {error ? (
        <div className='container'>
          <div
            className='alert alert-danger d-flex align-items-center'
            role='alert'
          >
            <div>{errorMessage}</div>
          </div>
        </div>
      ) : null}
    </>
  )
}

export default Nav
